export function getTypeOrderIsEntry(type: string | undefined) {
    return type == "purchase" || type == 'entry';
}